import createIcon from '../../createIcon';

/**
 * @component @name Airlines
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgNEwyIDIwSDE5TDIyIDRIMTNaTTE0LjUgMTRDMTMuMTIgMTQgMTIgMTIuODggMTIgMTEuNUMxMiAxMC4xMiAxMy4xMiA5IDE0LjUgOUMxNS44OCA5IDE3IDEwLjEyIDE3IDExLjVDMTcgMTIuODggMTUuODggMTQgMTQuNSAxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Airlines = createIcon('Airlines', [
  [
    'path',
    {
      d: 'M13 4L2 20H19L22 4H13ZM14.5 14C13.12 14 12 12.88 12 11.5C12 10.12 13.12 9 14.5 9C15.88 9 17 10.12 17 11.5C17 12.88 15.88 14 14.5 14Z',
      key: 'tzcbvi',
    },
  ],
]);

export default Airlines;
